<om-tos-update-modal
  #tosUpdateModal
  (dismissed)="handleDismissed(false)"
  (acknowledged)="handleDismissed(true)"
  [textContent]="modalContent$ | async"
></om-tos-update-modal>
